import styled, {css} from 'styled-components';

import {TextSmall} from '~atoms/Text';

export const InfoRow = styled.div`
    width: 100%;
    display: flex;
`;

type InfoColumnProps = {
    active: boolean;
};
export const InfoColumn = styled.div<InfoColumnProps>`
    width: 50%;
    display: flex;
    flex-direction: column;
    ${({active}) =>
        !active &&
        css`
            opacity: 0.5;

            span:first-child {
                opacity: 1;
            }
        `};
`;
export const Label = styled(TextSmall)`
    opacity: 0.5;
    margin: 3px 0;
`;

export const FlexCenter = styled.span`
    display: inline-flex;
    align-items: center;
`;
